import React, { Component } from "react";

class SelectTipoColegio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      error: ''
    };
    this.onChange = props.onChange;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.tipo !== prevState.value
      || nextProps.error !== prevState.error) {
      return {
        value: nextProps.tipo,
        error: nextProps.error
      };
    }
    return null;
  }

  handleChange = (event) => {
    event.preventDefault();
    const value = event.target.value;
    if (this.state.value !== value) {
      this.setState({ value: value }, this.onChange(this.props.name, value));
    }
  };

  render() {
    const { value, error } = this.state;

    return (
      <select
        value={value}
        onChange={this.handleChange}
        onBlur={this.handleChange}
        className={'custom-select' + (error ? ' is-invalid' : '')}
        required={this.props.required}
      >
        <option value=""></option>
        <option value="M">Municipal</option>
        <option value="E">Estadual</option>
        <option value="P">Particular</option>
      </select>
    )
  }
}

export default SelectTipoColegio;
